// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","mobileThreshold":"575px","container":"UndoRedoButtons_container__1fcgT","button":"UndoRedoButtons_button__8wEQR"};